/**
 * Primary teal colour
 */
export const primaryColors = {
  colorPrimary100: "#FFFFFF",
  colorPrimary99: "#04162d",
  colorPrimary95: "#C8F9FF",
  colorPrimary90: "#87F2FF",
  colorPrimary80: "#4ED8E9",
  colorPrimary70: "#21BCCC",
  colorPrimary60: "#00A0AF",
  colorPrimary50: "#008491",
  colorPrimary40: "#006974",
  colorPrimary30: "#004F57",
  colorPrimary20: "#00363C",
  colorPrimary10: "#001F23",
  colorPrimary0: "#000000",
};

/**
 * Greyscale
 */
export const neutralColors = {
  colorNeutral100: "#FFFFFF",
  colorNeutral99: "#FBFDFD",
  colorNeutral95: "#EFF1F1",
  colorNeutral90: "#E0E3E3",
  colorNeutral80: "#C4C7C7",
  colorNeutral70: "#A9ACAC",
  colorNeutral60: "#8E9191",
  colorNeutral50: "#747878",
  colorNeutral40: "#5C5F5F",
  colorNeutral30: "#444747",
  colorNeutral20: "#2D3131",
  colorNeutral10: "#191C1D",
  colorNeutral0: "#000000",
};

export const blueColors = {
  colorBlue70: "#0056D3",
};
